export default __webpack_public_path__ + "f1ad716498b2c0713f06e9c7252ce0fa.png";